import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class FechasService {
  fechaSeleccionada(fecha) {
    let today = new Date(fecha);

    let day = today.getDay();

    //console.log(this.dayOfWeek(day));
    let myfecha = this.dayOfWeek(day);
    return myfecha;
  }

  dayOfWeek(day) {
    let diaSemana = "";
    switch (day) {
      case 0:
        diaSemana = "Domingo";
        break;
      case 1:
        diaSemana = "Lunes";
        break;
      case 2:
        diaSemana = "Martes";
        break;
      case 3:
        diaSemana = "Miércoles";
        break;
      case 4:
        diaSemana = "Jueves";
        break;
      case 5:
        diaSemana = "Viernes";
        break;
      case 6:
        diaSemana = "Sábado";
        break;
      default:
    }
    return diaSemana;
  }

  fechaActual() {
    let today = new Date();
    let dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    let DD = "";
    let MM = "";
    if (dd < 10) {
      DD = "0" + dd;
    } else {
      DD = "" + dd;
    }

    if (mm < 10) {
      MM = "0" + mm;
    } else {
      MM = "" + mm;
    }

    let myfecha = MM + "/" + DD + "/" + yyyy;
    myfecha = yyyy + "-" + MM + "-" + DD;
    //console.log(myfecha);
    return myfecha;
  }
  mostrarFechaActual() {
    let today = new Date();
    let dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    let DD = "";
    let MM = "";
    if (dd < 10) {
      DD = "0" + dd;
    } else {
      DD = "" + dd;
    }

    if (mm < 10) {
      MM = "0" + mm;
    } else {
      MM = "" + mm;
    }

    let myfecha = MM + "/" + DD + "/" + yyyy;
    myfecha = DD + "/" + MM + "/" + yyyy;
    //console.log(myfecha);
    return myfecha;
  }

  mostrarhora() {
    let f = new Date();
    let hour = "";
    let min = "";
    if (f.getHours() < 10) {
      hour = "0" + f.getHours();
    } else {
      hour = "" + f.getHours();
    }
    if (f.getMinutes() < 10) {
      min = "0" + f.getMinutes();
    } else {
      min = "" + f.getMinutes();
    }

    let myHour = hour + ":" + min;

    return myHour;
  }

  arreglarfecha(fecha) {

    let arregloFecha = fecha.split("/");

    let myfecha = "";

    myfecha = arregloFecha[2] + "/" + arregloFecha[1] + "/" + arregloFecha[0];
    return myfecha;
  }

  arreglarfechaGuion(fecha) {

    let arregloFecha = fecha.split("-");

    let myfecha = "";

    myfecha = arregloFecha[2] + "/" + arregloFecha[1] + "/" + arregloFecha[0];
    return myfecha;
  }

  hora() {
    let fecha = new Date();
    let hora = "" + fecha.getHours();
    let min = "" + fecha.getMinutes();
    if (fecha.getHours() < 10) {
      hora = "0" + hora;
    }

    if (fecha.getMinutes() < 10) {
      min = "0" + min;
    }
    let myHour = hora + ":" + min;

    return myHour;
  }

  listadoMesesValue() {
    let meses = [
      { label: "", value: null },
      { label: "enero", value: "enero" },
      { label: "febrero", value: "febrero" },
      { label: "marzo", value: "marzo" },
      { label: "abril", value: "abril" },
      { label: "mayo", value: "mayo" },
      { label: "junio", value: "junio" },
      { label: "julio", value: "julio" },
      { label: "agosto", value: "agosto" },
      { label: "septiembre", value: "septiembre" },
      { label: "octubre", value: "octubre" },
      { label: "noviembre", value: "noviembre" },
      { label: "diciembre", value: "diciembre" }
    ];

    return meses;
  }
  listadoMesesValueNumber() {
    let meses: any[] = [
      { label: "Enero", value: 0 },
      { label: "Febrero", value: 1 },
      { label: "Marzo", value: 2 },
      { label: "Abril", value: 3 },
      { label: "Mayo", value: 4 },
      { label: "Junio", value: 5 },
      { label: "Julio", value: 6 },
      { label: "Agosto", value: 7 },
      { label: "Septiembre", value: 8 },
      { label: "Octubre", value: 9 },
      { label: "Noviembre", value: 10 },
      { label: "Diciembre", value: 11 }
    ];

    return meses;
  }
  listadoMeses() {
    let meses = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    ];

    return meses;
  }
  diasEnUnMes(mes, año) {
    return new Date(año, mes, 0).getDate();
  }
  filtrarMesValue(value) {
    let number = this.listadoMesesValueNumber();

    number.forEach(element => {
      //console.log("number",element);
    });
  }

  getYear(value) {
    let year = new Date(value);
    return year.getFullYear();
  }

  getMonth(value) {
    let mes = new Date(value);
    return mes.getMonth() + 1;
  }

  seleccionarMes(mes) {
    let month = "";
    switch (mes) {
      case 1:
        month = "Enero";
        break;
      case 2:
        month = "Febrero";
        break;
      case 3:
        month = "Marzo";
        break;
      case 4:
        month = "Abril";
        break;
      case 5:
        month = "Mayo";
        break;
      case 6:
        month = "Junio";
        break;
      case 7:
        month = "Julio";
        break;
      case 8:
        month = "Agosto";
        break;
      case 9:
        month = "Septiembre";
        break;
      case 10:
        month = "Octubre";
        break;
      case 11:
        month = "Noviembre";
        break;
      case 12:
        month = "Diciembre";
        break;
      default:
    }
    return month;
  }
  /**
   *
   *
   * @param {string} fecha
   * @returns
   * @memberof FechasService
   * arreglar fecha para el componente calendar
   * cuando recibimos el valor de la base de datos
   *
   */
  fechaUpdate(fecha: string) {
    if (fecha == null || fecha == undefined || fecha.length == 0) {
      return "";
    }
    // al ser de tipo Date se inserta automáticamente este valor si no valor insertado
    if (fecha.localeCompare("0000-00-00") == 0) {
      return "";
    }
    let today = new Date(fecha);
    //console.log('today', today);
    return today;
  }

  /**
   *
   *
   * @param {string} fecha
   * @returns
   * @memberof FechasService
   * Arreglar fecha a la hora de introducir valores en la base de datos
   * desde el componente calendar, pero hay que crear un nuevo objecto de
   * datos para su correcta en la base de datos, ya que si se intenta modificar
   * el valor del calendar, la aplicación deja de funcionar y no envia a la base de datos.
   *
   */
  arreglarFecha(fecha: string) {
    if (fecha == null || fecha == undefined || fecha.length == 0) {
      return "";
    }
    let today = new Date(fecha);

    let dd = today.getDate();
    let DD = "";
    var mm = today.getMonth() + 1; //January is 0!
    let MM = "";
    var yyyy = today.getFullYear();
    if (mm < 10) {
      MM = "0" + mm;
    } else {
      MM = "" + mm;
    }
    if (dd < 10) {
      DD = "0" + dd;
    } else {
      DD = "" + dd;
    }

    let myfecha = MM + "/" + DD + "/" + yyyy;
    myfecha = yyyy + "-" + MM + "-" + DD;
    // console.log(myfecha);
    return myfecha;
  }

  fechaCalendar() {
    let today = new Date();
    return today;
  }

  fechaCalendarAddDay(day: number) {
    let today = new Date();
    today.setDate(today.getDate() + day);
    return today;
  }

  fechaCalendarNewDateAddDay(fecha: Date, day: number) {
    let today = new Date(fecha);
    today.setDate(today.getDate() + day);
    return today;
  }
}
